import { addSeconds, Duration, intervalToDuration } from 'date-fns';
import { forceTwoDigits } from 'utils/sanitizers';
import { formatInTimeZone, toDate } from 'date-fns-tz';

// Convert a date to a Paris-timezone-aware Date object
const toParisDate = (date: Date | string | number): Date =>
  toDate(formatInTimeZone(date, 'Europe/Paris', 'yyyy-MM-dd HH:mm:ss'), {
    timeZone: 'Europe/Paris',
  });

// Compute the duration between two dates, both interpreted in the Paris timezone
export const parisIntervalToDuration = (
  start: Date | string | number,
  end: Date | string | number,
): Duration =>
  intervalToDuration({ start: toParisDate(start), end: toParisDate(end) });

// Convert a seconds count into a Duration (minutes + seconds) via an offset from now
export const secondsToDuration = (seconds: number): Duration =>
  intervalToDuration({
    start: new Date(),
    end: addSeconds(new Date(), seconds),
  });

// Format a Duration as a "MM:SS" string using only minutes and seconds
export const formatMMSS = (duration: Duration): string =>
  `${forceTwoDigits(duration.minutes)}:${forceTwoDigits(duration.seconds)}`;
